// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "0.7.89/js/resources/" + chunkId + ".js";
};